import {
  Box,
  Container,
  Typography,
  Grid,
  useMediaQuery,
  Icon,
} from "@mui/material";
import React, { useState } from "react";
import { icons, images } from "../../assets";
import { allColors } from "../../constants";
import GlobalButton from "../../components/globalButton";
import { useNavigate } from "react-router-dom";

const sectionData = [
  {
    id: 1,
    title: "Digital Phone Line",
    price: "£16.99",
    bgColor: "linear-gradient(to right, #88b7ff, #cde1ff)",
    image: images.yeaLinkPhoneImgNew,
    options: [
      {
        id: 1,
        image: icons.circleDownload1Icon,
        icon: "download",
        title: "Download the app to your device",
      },
      {
        id: 2,
        image: icons.circlePhone1Icon,
        icon: "phone_in_talk",
        title: "Make and receive calls on the go",
      },
      {
        id: 3,
        image: icons.circleEuro1Icon,
        icon: "currency_pound",
        title: "Pay as you go",
      },
    ],
    showMore: false,
  },
  {
    id: 2,
    title: "Digital Phone & Calls",
    price: "£22.99",
    bgColor: "linear-gradient(to right, #cde1ff, #eeeeee)",
    image: images.yeaLinkPhoneBlackImgNew,
    options: [
      {
        id: 1,
        image: icons.circleDownload1Icon,
        icon: "download",
        title: "Download the app to your device",
      },
      {
        id: 2,
        image: icons.circlePhone1Icon,
        icon: "phone_in_talk",
        title: "Make and receive calls on the go",
      },
      {
        id: 3,
        image: icons.circleinfinityIcon,
        icon: "all_inclusive",
        title: "Unlimited UK landline & mobile calls",
      },
    ],
    showMore: false,
  },
];

const PhoneOnlySection = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [phoneOnlyData, setPhoneOnlyData] = useState(sectionData);
  const navigate = useNavigate();

  const handleShowMore = (inddddd) => {
    let tempArrr = [...phoneOnlyData];
    tempArrr[inddddd].showMore = !tempArrr[inddddd].showMore;
    setPhoneOnlyData(tempArrr);
  };

  return (
    <Container
      sx={{
        maxWidth: "1250px !important",
        textAlign: "center",
        marginTop: "30px",
        paddingBottom: "22px",
      }}
      id="phone-only"
    >
      <Typography
        sx={{
          textAlign: "center",
          fontSize: { xs: "22px", sm: "35px", md: "50px" },
          color: allColors.jetBlack,
          fontFamily: "Raleway",
          fontWeight: "400",
          marginBottom: "35px",
        }}
      >
        Phone Only
      </Typography>

      <Grid container spacing={3} justifyContent={"space-around"}>
        {phoneOnlyData.map((itemmmm, index) => {
          return (
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  background: itemmmm.bgColor,
                  padding: {
                    xs: "15px 24px 24px 18px",
                    sm: "15px 24px 24px 44px",
                  },
                  borderRadius: "20px",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    background: allColors.jasmine,
                    borderRadius: "20px",
                    padding: "5px",
                    display: { xs: "block", sm: "none" },
                    textAlign: "center",
                    width: "80%",
                    margin: "10px auto 12px",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Raleway",
                      fontSize: { xs: "20px", md: "28px" },
                      color: allColors.jetBlack,
                      fontWeight: "400",
                    }}
                  >
                    {itemmmm.title}{" "}
                  </Typography>
                </Box>
                <Grid
                  container
                  spacing={3}
                  // flexDirection={{ xs: "column-reverse", md: "row" }}
                  alignItems={{ xs: "center", sm: "flex-end" }}
                >
                  <Grid item xs={7.2} md={7}>
                    <Box
                      sx={{
                        background: allColors.jasmine,
                        borderRadius: "10px",
                        padding: "5px",
                        display: { xs: "none", sm: "block" },
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Raleway",
                          fontSize: { xs: "20px", md: "28px" },
                          color: allColors.jetBlack,
                          fontWeight: "400",
                        }}
                      >
                        {itemmmm.title}{" "}
                      </Typography>
                    </Box>
                    <Typography
                      sx={{
                        fontFamily: "Squad-Regular",
                        fontSize: { xs: "40px", md: "50px" },
                        color: allColors.jetBlack,
                        fontWeight: "700",
                        textAlign: "left",
                        marginTop: "10px",
                        marginLeft: { xs: "20px", sm: 0 },
                      }}
                    >
                      {itemmmm.price}
                      <span
                        style={{ fontSize: isSmallScreen ? "10px" : "14px" }}
                      >
                        p/m
                      </span>
                    </Typography>

                    {itemmmm.options.map((optiionn) => {
                      return (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "10px",
                            marginLeft: { xs: "5px", sm: 0 },
                          }}
                        >
                          {optiionn.icon == "phone_in_talk" ||
                          optiionn.icon == "currency_pound" ? (
                            <img
                              src={optiionn.image}
                              alt={optiionn.image}
                              style={{
                                width: isSmallScreen ? "35px" : "45px",
                                height: isSmallScreen ? "35px" : "45px",
                                marginRight: "10px",
                              }}
                            />
                          ) : (
                            <Box
                              sx={{
                                background: allColors.jetBlack,
                                borderRadius: "50%",
                                padding: { xs: "5px", sm: "10px" },
                                marginRight: "10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Icon
                                sx={{
                                  color: index == 0 ? "#88b7ff" : "#cde1ff",
                                }}
                              >
                                {optiionn.icon}
                              </Icon>
                            </Box>
                          )}
                          <Typography
                            sx={{
                              fontSize: { xs: "12px", sm: "14px" },
                              color: allColors.jetBlack,
                              fontWeight: "400",
                              textAlign: "left",
                            }}
                          >
                            {optiionn.title}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Grid>
                  <Grid item xs={4.8} md={5}>
                    <img
                      src={itemmmm.image}
                      style={{
                        width: isSmallScreen
                          ? "100%"
                          : index == 0
                          ? "155px"
                          : "165px",
                      }}
                    />
                  </Grid>
                </Grid>

                {itemmmm.showMore && (
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "14px" },
                      color: allColors.jetBlack,
                      fontWeight: "400",
                      textAlign: "center",
                      margin: "20px 0",
                    }}
                  >
                    VAT excluded from price. Contract length of 18, 24 or 36
                    months. £60 digital installation upgrade fees may apply.{" "}
                    <span
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => navigate("/tariff-guide")}
                    >
                      Call charges
                    </span>
                    .{" "}
                    <span
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => navigate("/tariff-guide")}
                    >
                      International call rates
                    </span>
                    .{" "}
                    <span
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => navigate("/voip-terms-&-conditions")}
                    >
                      Full T&Cs
                    </span>
                    .
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  // position: "absolute",
                  // bottom: "-15px",
                  // left: "40%",
                  position: "relative",
                  marginTop: "-22px",
                }}
              >
                {!itemmmm.showMore ? (
                  <GlobalButton
                    handleClickBtn={() => handleShowMore(index)}
                    title={"Show More"}
                    style={{
                      background: allColors.white,
                      color: allColors.jetBlack,
                      border: `1px solid ${allColors.frenchSkyBlue}`,
                      borderRadius: "10px",
                      fontSize: "12px",
                      padding: { xs: "10px 40px", sm: "10px 20px" },
                    }}
                  />
                ) : (
                  <a href={"#contact-us"}>
                    <GlobalButton
                      handleClickBtn={() => handleShowMore(index)}
                      title={"Switch today"}
                      style={{
                        background: allColors.blueCrayola,
                        color: allColors.white,
                        border: `1px solid ${allColors.blueCrayola}`,
                        borderRadius: "10px",
                        fontSize: "12px",
                        padding: { xs: "10px 40px", sm: "10px 20px" },
                      }}
                    />
                  </a>
                )}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default PhoneOnlySection;
